import api from "../api";

const endpoint = {
    fetchStrings: () => {
        return api.get("/strings")
    }
}

export default endpoint;